import styled from 'styled-components';
import { cssWhiteSection } from 'components/base/common-styles';
import { SPACES } from 'common/constants/sizes';

export const StyledTabs = styled.header`
  ${cssWhiteSection};
  padding: 0 ${SPACES.medium};
`;
export const StyledRoutes = styled.main``;

export const StyledRouterTabs = styled.div``;
